import newsletterModal from './newsletter-modal';

class Blog {
  constructor(element) {
    this.element = element;
    this.categories = this.element.querySelectorAll('[data-element="blog-category"]');
    this.list = this.element.querySelector('[data-element="blog-list"]');
    this.loadMore = this.element.querySelector('[data-element="blog-load-more"]');
    this.loadMoreBtn = this.element.querySelector('[data-element="blog-load-more-btn"]');
    this.loadMoreLoader = this.element.querySelector('[data-element="blog-load-more-loader"]');
    this.rest = wpRestApi; // eslint-disable-line
    this.page = 2;
    this.category = 0;
    this.tag = 0;
  }

  init() {
    this.checkTerms();
    this.loadMoreBtn.addEventListener('click', this.onLoadMoreBtnClick.bind(this));
    this.categories.forEach((category) => {
      category.addEventListener('click', this.onCategoryClick.bind(this, category));
    });
  }

  checkTerms() {
    if (this.element.hasAttribute('data-category')) {
      this.category = this.element.dataset.category;
    }
    if (this.element.hasAttribute('data-tag')) {
      this.tag = this.element.dataset.tag;
    }
  }

  onLoadMoreBtnClick() {
    this.loadPosts();
  }

  onCategoryClick(category) {
    if (category.classList.contains('is-active')) {
      return;
    }

    this.removeAllCategoriesActive();
    category.classList.add('is-active');
    this.clearPosts();
    this.showLoadMore();
    this.page = 1;
    this.category = category.dataset.id;
    this.loadNewsletter = true;
    this.loadPosts();
  }

  loadPosts() {
    this.showLoader();

    const url = new URL(this.rest.url + 'blog/load-more');
    url.searchParams.append('category', this.category);
    url.searchParams.append('page', this.page);

    fetch(url.href, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (null !== data.html) {
        this.list.insertAdjacentHTML('beforeend', data.html);
      }

      if (true === data.hideBtn) {
        this.hideLoadMore();
      }

      this.page++;
      this.hideLoader();
      newsletterModal.init();
    }).catch((error) => {
      console.error(error);
      this.hideLoader();
    });
  }

  clearPosts() {
    this.list.replaceChildren();
  }

  removeAllCategoriesActive() {
    this.categories.forEach((category) => {
      category.classList.remove('is-active');
    });
  }

  hideLoadMore() {
    this.loadMore.classList.add('blog-list__load-more--hidden');
  }

  showLoadMore() {
    this.loadMore.classList.remove('blog-list__load-more--hidden');
  }

  hideLoader() {
    this.loadMoreLoader.classList.remove('blog-list__loader--show');
  }

  showLoader() {
    this.loadMoreLoader.classList.add('blog-list__loader--show');
  }
}

const blog = {
  init() {
    const blogElement = document.querySelector('[data-module="blog"]');

    if (blogElement) {
      const blogItem = new Blog(blogElement);
      blogItem.init();
    }
  },
};

export default blog;
